"use strict";

import React, {Component} from 'react';

class Wrapper extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="wrapper">
                {this.props.children}
            </div>
        )
    }
}

export default Wrapper;